<template>
    <v-container fluid>
        <v-toolbar color="indigo lighten-5" elevation="0">
            <v-toolbar-title>Profil</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click="editMode = true" :disabled="editMode">
                    <v-icon left>mdi-pencil</v-icon>
                    Edit
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-row justify="center">
            <v-col cols="12">
                <v-card class="profile-card" style="border:1px solid whitesmoke" elevation="0">
                    <v-row>
                        <v-col cols="12" sm="4" class="profile-picture-column">
                            <v-avatar size="200" >
                                <v-img v-if="user.avatar" height="100%" width="100%" cover :src="profilePicture" alt="Profile Picture" />
                                <v-img v-else height="100%" width="100%" cover :src="'https://static.vecteezy.com/system/resources/thumbnails/002/534/006/small/social-media-chatting-online-blank-profile-picture-head-and-body-icon-people-standing-icon-grey-background-free-vector.jpg'" alt="Profile Picture" />
                            </v-avatar>
                            <br>
                            <!-- <v-btn class="upload-button border" :disabled="!editMode" color="primary" text @click="uploadProfilePicture">
                                Ubah foto
                            </v-btn>
                            <input type="file" ref="profilePictureInput" style="display: none"
                                @change="updateProfilePicture" accept="image/*" /> -->
                        </v-col>
                        <v-col cols="12" sm="8" class="profile-info-column">
                            <v-text-field filled v-model="user.name" readonly  label="Nama" dense>
                            </v-text-field>
                            <v-text-field filled v-model="user.no_induk" readonly  label="No induk" dense></v-text-field>
                            <v-text-field filled v-model="user.email" type="email" readonly  label="Email"
                                dense></v-text-field>
                            <v-text-field filled v-model="formUser.no_hp" label="No Hp" dense :readonly="!editMode" ></v-text-field>
                            <template v-if="role.includes(2) || role.includes(3)">
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-file-input solo dense v-model="signatureFile" color="indigo darken-4" counter
                                            label="Unggah tanda tangan" placeholder="Select your files" :disabled="!editMode"
                                            @change="handleSignatureUpload" prepend-icon="mdi-signature-image"
                                            :show-size="1000">
                                            <template v-slot:selection="{ index, text }">
                                                <v-chip v-if="index < 2" color="indigo darken-4" dark label small>
                                                    {{ text }}
                                                </v-chip>

                                                <span v-else-if="index === 2"
                                                    class="text-overline grey--text text--darken-3 mx-2">
                                                    +{{ files.length - 2 }} File(s)
                                                </span>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-card class="p-2 border d-flex justify-content-center align-center" elevation="0"
                                            height="100px" width="100%">
                                            <v-img v-if="signature" :src="signature" alt="Signature" contain width="100%"
                                                height="100%"></v-img>
                                            <span v-else class="no-signature">Tanda tangan belum di unggah</span>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-col>
                        <v-col cols="12" md="12">
                            <div class="d-flex justify-content-center" >
                            <v-btn v-if="editMode" color="primary" @click="submit()">Simpan</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            profilePicture: null,
            editMode: false,
            user: JSON.parse(localStorage.getItem("user")),
            role: null,
            signatureFile: null,
            signature: '',
            formUser: {
                avatar: null,
                no_hp: null,
                tanda_tangan: null,
            }
        };
    },
    created() {
        this.getData();
        this.role = this.user.roles.map(ro => {
            return ro.id;
        })
        this.profilePicture = this.user.avatar;
        this.signatureFile = this.user.tanda_tangan;

    },
    methods: { 
        getData() {
            this.isLoading = true;
            this.axios.get("/api/user/"+this.user.id).then((res) => {
                this.user = res.data.data;
                this.profilePicture = this.user.avatar;
                console.log(this.profilePicture, 'this.profilePicture');
                this.signatureFile = this.user.tanda_tangan;
                this.formUser.no_hp = this.user.no_hp;
                this.role = this.user.roles.map(ro => {
                    return ro.id;
                })
            }).finally(() => this.isLoading = false);
        },
        uploadProfilePicture() {
            this.$refs.profilePictureInput.click();
        },
        updateProfilePicture(event) {
            const file = event.target.files[0];
            this.formUser.avatar = file ?  file : null;
            console.log(this.formUser);

            const reader = new FileReader();

            reader.onload = (e) => {
                this.profilePicture = e.target.result;
            };

            reader.readAsDataURL(file);
        },
        handleSignatureUpload() {
            if (this.signatureFile) {
                const reader = new FileReader();
                this.formUser.tanda_tangan = this.signatureFile;
            console.log(this.formUser);


                reader.onload = (e) => {
                    this.signature = e.target.result;
                };

                reader.readAsDataURL(this.signatureFile);
            } else {
                this.formUser.tanda_tangan = null;
            }
        },
        submit() {
            console.log(this.formUser);
            let url = "/api/user/"+this.user.id;
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: true,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                this.formUser["_method"] = "put";
                let formData = new FormData();
                formData = serialize(this.formUser, options);
                if (this.signatureFile) 
                    formData.append('tanda_tangan', this.signatureFile);
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil ubah data");
                        this.$router.push({ name: "profile" });
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.editMode = false;
                    });
            }
    },
};
</script>
  
<style scoped>
.profile-card {
    padding: 24px;
}

.profile-picture-column {
    text-align: center;
}

.upload-button {
    margin-top: 16px;
}

.profile-info-column {
    padding-left: 20px;
}

.no-signature {
    color: grey;
    display: block;
}
</style>